// extracted by mini-css-extract-plugin
export default {"list":"SubscriptionDetailsList_list__oksez","listItem":"SubscriptionDetailsList_listItem__5KY0J","listIcon":"SubscriptionDetailsList_listIcon__YVEMf"};